module.exports = __webpack_public_path__ + "static/media/data-inactive.478109ce.svg";